import React from 'react';

import SuperSearchDropdown from 'NewComponents/FormComponents/SuperSearchDropdown/SuperSearchDropdown';
import CptSuperSearchInput from './CptSuperSearchInput';
import CptSuperSearchTemplate from './CptSuperSearchTemplate';
import CustomLabel from 'Common/CustomLabel/CustomLabel';

const CptSuperSearch = ({ searchValue, onChange, handleSelectedData, label, labelRequired,Icon, toolTip, disabled, identifier = 'CptSuperSearch' }) => {
  return (
    <div className='w-full flex flex-col gap-2'>
      {label ? <CustomLabel label={label} required={labelRequired} toolTip={toolTip} Icon={Icon} /> : null}
    <SuperSearchDropdown handleSelectedData={handleSelectedData}>
      <SuperSearchDropdown.Input>
        <CptSuperSearchInput
          disabled={disabled}
          searchValue={searchValue}
          onChange={onChange}
          handleSelectedData={handleSelectedData}
          identifier={identifier}
          placeholder='Search CPT...'
        />
      </SuperSearchDropdown.Input>
      <SuperSearchDropdown.Container>
        <CptSuperSearchTemplate width='100%' handleSelectedData={handleSelectedData} identifier={identifier} />
      </SuperSearchDropdown.Container>
    </SuperSearchDropdown>
    </div>
  );
};

export default CptSuperSearch;
